import React from "react";
import { Row, Col, Typography, Button, Grid } from "antd";
import {
  ShopOutlined,
  BuildOutlined,
  TeamOutlined,
  ReloadOutlined,
  ArrowRightOutlined,
} from "@ant-design/icons";

const { Title, Paragraph } = Typography;
const { useBreakpoint } = Grid;

const audienceItems = [
  {
    icon: <ShopOutlined />,
    title: "Marcas de Semijoias e Bijuterias",
    description:
      "Para marcas que precisam de acabamento premium e mais valor percebido no produto final.",
  },
  {
    icon: <BuildOutlined />,
    title: "Fabricantes",
    description:
      "Suporte para operações que exigem padronização, controle técnico e constância no processo.",
  },
  // {
  //   icon: <TeamOutlined />,
  //   title: "Revendedores",
  //   description:
  //     "Ideal para quem busca peças com apresentação mais refinada e melhor percepção comercial.",
  // },
  {
    icon: <ReloadOutlined />,
    title: "Produção recorrente",
    description:
      "Estrutura pensada para atender demandas contínuas com mais organização e previsibilidade.",
  },
];

function WhoWeServeSection() {
  const screens = useBreakpoint();
  const isDesktop = screens.lg;

  return (
    <section
      style={{
        padding: isDesktop ? "96px 24px" : "72px 16px",
        background: "#f8f6f2",
      }}
    >
      <div style={{ maxWidth: 1280, margin: "0 auto" }}>
        <Row gutter={isDesktop ? [40, 28] : [0, 32]} align="middle">
          <Col xs={24} lg={9}>
            <div style={{ maxWidth: isDesktop ? 500 : "100%" }}>
              <span
                style={{
                  display: "inline-block",
                  padding: isDesktop ? "8px 14px" : "7px 12px",
                  borderRadius: 999,
                  background: "rgba(210,171,113,0.12)",
                  border: "1px solid rgba(210,171,113,0.24)",
                  color: "#a8844f",
                  fontSize: isDesktop ? 13 : 12,
                  fontWeight: 700,
                  letterSpacing: 0.4,
                  marginBottom: 18,
                }}
              >
                ATENDIMENTO B2B
              </span>

              <Title
                level={2}
                style={{
                  marginBottom: 18,
                  color: "#1f1f1f",
                  fontSize: isDesktop ? "clamp(34px, 4vw, 50px)" : "32px",
                  lineHeight: isDesktop ? 1.08 : 1.15,
                }}
              >
                Para quem é o nosso serviço de Banho de Ouro
              </Title>

              <Paragraph
                style={{
                  fontSize: isDesktop ? 18 : 16,
                  lineHeight: 1.75,
                  color: "#666",
                  marginBottom: 26,
                }}
              >
                Atendemos operações que precisam de padrão visual, consistência
                no acabamento e confiança no processo. Nosso serviço é ideal
                para empresas que buscam um parceiro técnico para elevar a
                percepção de valor das peças.
              </Paragraph>

              <div
                style={{
                  background: "#ffffff",
                  borderRadius: 22,
                  padding: isDesktop ? "24px 22px" : "20px 18px",
                  border: "1px solid #eadfce",
                  boxShadow: "0 10px 28px rgba(0,0,0,0.05)",
                  marginBottom: 24,
                }}
              >
                <div
                  style={{
                    fontSize: 13,
                    fontWeight: 700,
                    letterSpacing: 0.4,
                    color: "#a8844f",
                    marginBottom: 8,
                  }}
                >
                  POSICIONAMENTO PROFISSIONAL
                </div>

                <Paragraph
                  style={{
                    marginBottom: 0,
                    color: "#444",
                    fontSize: isDesktop ? 16 : 15,
                    lineHeight: 1.65,
                  }}
                >
                  Mais do que executar o banho, atuamos como parceiro para
                  operações que exigem previsibilidade, qualidade visual e mais
                  confiança no resultado final.
                </Paragraph>
              </div>

              {/* <Button
                type="primary"
                size="large"
                icon={<ArrowRightOutlined />}
                style={{
                  height: 48,
                  width: isDesktop ? "fit-content" : "100%",
                  padding: isDesktop ? "0 24px" : "0 18px",
                  borderRadius: 999,
                  background: "#111111",
                  borderColor: "#111111",
                  fontWeight: 600,
                  boxShadow: "0 10px 24px rgba(0,0,0,0.10)",
                }}
              >
                Falar com especialista
              </Button> */}
            </div>
          </Col>

          <Col xs={24} lg={15}>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: isDesktop ? "1fr 1fr" : "1fr",
                gap: isDesktop ? 20 : 16,
              }}
            >
              {audienceItems.map((item) => (
                <div
                  key={item.title}
                  style={{
                    background: "#ffffff",
                    borderRadius: isDesktop ? 24 : 20,
                    padding: isDesktop ? "28px 24px" : "22px 18px",
                    border: "1px solid #eadfce",
                    boxShadow: "0 12px 32px rgba(0,0,0,0.05)",
                    minHeight: isDesktop ? 220 : "auto",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "flex-start",
                  }}
                >
                  <div
                    style={{
                      width: 62,
                      height: 62,
                      borderRadius: 18,
                      background: "linear-gradient(135deg, #d2ab71, #bb9259)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: "#fff",
                      fontSize: 26,
                      boxShadow: "0 10px 22px rgba(187,146,89,0.22)",
                      marginBottom: 18,
                    }}
                  >
                    {item.icon}
                  </div>

                  <Title
                    level={3}
                    style={{
                      fontSize: isDesktop ? 22 : 20,
                      lineHeight: 1.2,
                      marginBottom: 12,
                      color: "#1f1f1f",
                    }}
                  >
                    {item.title}
                  </Title>

                  <Paragraph
                    style={{
                      marginBottom: 0,
                      color: "#666",
                      fontSize: isDesktop ? 16 : 15,
                      lineHeight: 1.7,
                    }}
                  >
                    {item.description}
                  </Paragraph>
                </div>
              ))}
            </div>
          </Col>
        </Row>
      </div>
    </section>
  );
}

export default WhoWeServeSection;